export default __webpack_public_path__ + "assets/c469e23959fd19cc40fbb5e56c083c86.png";